import React from 'react'
import './about.css'
import Me from '../../asset/images/222.png'

function about() {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About Me</h2>


      <div className="container about_container">
        <div className="about_me">
          <div className="about_me-images">
            <img src={Me} alt="about me images" />

          </div>
          </div>
          
          <div className="about_content">
            
              <article>  I am Mansurul Hoque Abrar. I am studying computer science. Always curious about the latest technology and updates in the web development field. I had a lot of interest in technology since school life. And before school life was over I became familiar with computer programming. Since then programming has been my main focus. I am looking for an opportunity to apply my skills and contribute to the growth of the company. For now, there is nothing more to say. </article>

              <a href="#contact" className='btn btn-primary'>Lets Talk</a>
            


          
        </div>
      </div>

    </section>
  )
}

export default about